/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M18 8h-8V0H8v8H0v2h8v8h2v-8h8V8z" _fill="#15161a" fill-rule="evenodd"/>'
  }
})
